import { render, staticRenderFns } from "./addDependentsPopup.vue?vue&type=template&id=4d8a3ae0&scoped=true"
import script from "./addDependentsPopup.vue?vue&type=script&lang=js"
export * from "./addDependentsPopup.vue?vue&type=script&lang=js"
import style0 from "./addDependentsPopup.vue?vue&type=style&index=0&id=4d8a3ae0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8a3ae0",
  null
  
)

export default component.exports